import { render, staticRenderFns } from "./PaginationWidget.vue?vue&type=template&id=70da71a8&scoped=true&lang=pug&"
import script from "./PaginationWidget.vue?vue&type=script&lang=js&"
export * from "./PaginationWidget.vue?vue&type=script&lang=js&"
import style0 from "./PaginationWidget.vue?vue&type=style&index=0&id=70da71a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70da71a8",
  null
  
)

export default component.exports